export default __webpack_public_path__ + "static/media/favorites-airtags-comp.147ed6c3.png";